<ng-container *ngIf="!hasToBeTouched || (control.touched || control.dirty)">
  <ng-container *ngIf="control.errors as errors">
    <div class="flex flex-col gap-1 input-error-message">
      <!-- Server-side error pushed onto the control by the page after a 422.
           The message is already localised + field-labelled by the caller
           (see `vehicle-form-page.onError`). Rendered first so it sits at
           the top of the error stack, above any client-side validators. -->
      <div class="flex-1" *ngIf="errors.serverError">
        {{ errors.serverError }}
      </div>

      <div class="flex-1" *ngIf="errors.customError">
        <span i18n="Form validation error">Napaka:</span>&nbsp;{{ control.errors.customError }}.
      </div>

      <div class="flex-1" *ngIf="errors.min">
        <span i18n="Form validation error">Mora biti večje od</span>&nbsp;{{ control.errors.min.min }}.
      </div>

      <div class="flex-1" *ngIf="errors.minlength && field && field.type === 'photos'">
        <span i18n="Form validation error">Dodati morate vsaj</span>&nbsp;{{ control.errors.minlength.requiredLength }}&nbsp;slik.
      </div>

      <div class="flex-1" *ngIf="errors.minlength && (!field || field.type !== 'photos')">
        <span i18n="Form validation error">Mora biti daljše/več kot</span>&nbsp;{{ control.errors.minlength.requiredLength }}
        .
      </div>

      <div class="flex-1" *ngIf="errors.max">
        <span i18n="Form validation error">Mora biti manjše od</span>&nbsp;{{ control.errors.max.max }}.
      </div>

      <div class="flex-1" *ngIf="errors.maxPercent">
        <span i18n="Form validation error">Mora biti manjše od</span>&nbsp;{{ control.errors.maxPercent.max }}
        <span> %.</span>
      </div>

      <div class="flex-1" *ngIf="errors.maxlength">
        <span i18n="Form validation error">Mora biti krajše/manj kot</span>&nbsp;{{ control.errors.maxlength.requiredLength }}
        .
      </div>

      <div class="flex-1" *ngIf="errors.sameValue">
        <span i18n="Form validation error">Vrednosti ne smejo biti enake</span>
      </div>

      <!-- Suppressed when a serverError is present: the gap-marking pass writes
           the very same "Polje je obvezno." line as a serverError, so a required
           control that is also an open gap printed it twice (BRIEFD-7404). The
           serverError copy is the more specific of the two and renders first. -->
      <div class="flex-1" *ngIf="errors.required && !errors.serverError">
        <span i18n="Form validation error">Polje je obvezno.</span>
      </div>

      <div class="flex-1" *ngIf="errors.pattern">
        <span i18n="Form validation error">Napačna oblika!</span>
      </div>

      <div class="flex-1" *ngIf="errors.email">
        <span i18n="Form validation error">E-poštni naslov ni veljaven!</span>
      </div>

      <div class="flex-1" *ngIf="errors.prefixError">
        <span i18n="Form validation error">Se mora začeti z: {{ errors.prefixError.requiredPrefix }}</span>
      </div>

      <div class="flex-1" *ngIf="errors.upnReferenceError">
        <span i18n="Form validation error">Sklic ima napačno obliko ali se ne začne z: {{ errors.upnReferenceError.requiredPrefixes.join(', ') }}</span>
      </div>

      <div class="flex-1" *ngIf="errors.invalidIban">
        <span i18n="Form validation error">IBAN je v napačni obliki</span>
      </div>

      <div class="flex-1" *ngIf="errors.addikoEmployer">
        <span i18n="Form validation error">Zaposleni pri Addiku ne morejo biti zaposleni v tujini</span>
      </div>

      <div class="flex-1" *ngIf="errors.matDatepickerParse">
        <span i18n="Form validation error">Datum je v napačni obliki</span>
      </div>

      <div class="flex-1" *ngIf="errors.matDatepickerMax">
        <span i18n="Form validation error">Datum je omejen navzgor</span>: {{ errors.matDatepickerMax.max }}
      </div>

      <div class="flex-1" *ngIf="errors.matDatepickerMin">
        <span i18n="Form validation error">Datum je omejen navzdol:</span> {{ errors.matDatepickerMin.min }}
      </div>

      <div class="flex-1" *ngIf="errors.mustBeAfter">
        <span i18n="Form validation error">Datum mora biti po začetnem datumu</span>
      </div>

      <div class="flex-1" *ngIf="errors.mustBeBefore">
        <span i18n="Form validation error">Datum mora biti pred končnim datumom</span>
      </div>

      <div class="flex-1" *ngIf="errors.allowOnlyUrls">
        <span i18n="Form validation error">Vrednost mora biti veljavna URL povezava</span>
      </div>

      <div class="flex-1" *ngIf="errors.incompleteLocation">
        <span i18n="Form validation error">Izberite regijo, občino in kraj.</span>
      </div>
    </div>
  </ng-container>
</ng-container>
